export const CHECKOUT_URL =
  'https://metodo-maestro-amigurumi.impultienda.ar/checkout'

export const PRICE = 19990
export const PRICE_LABEL = '$19.990'

export const skills = [
  {
    title: 'El Idioma del Crochet',
    description:
      'Aprendé a leer patrones y diagramas como una experta. Nunca más vas a depender de un video.',
  },
  {
    title: 'Técnica Invisible',
    description:
      'Lográ puntos firmes y parejos para que no se vea el relleno.',
  },
  {
    title: 'Escultura con Lana',
    description:
      'Secretos de costura y articulación para que tus muñecos tengan expresiones reales y tiernas.',
  },
  {
    title: 'Materiales Pro',
    description:
      'Guía de qué comprar en Argentina para ahorrar dinero y obtener la mejor calidad.',
  },
]

export const painPoints = [
  'Videos mal explicados que ocultan los detalles importantes.',
  'Patrones mal traducidos que confunden a cualquiera.',
  'Técnicas de relleno que dejan a tus muñecos “flojos” y sin vida.',
]

export type PackItem = {
  label: string
  name: string
  detail: string
  value: number
  isBonus: boolean
}

export const packItems: PackItem[] = [
  {
    label: '📘',
    name: 'El Manual Maestro Amigurumi',
    detail: 'Paso a paso ilustrado',
    value: 15000,
    isBonus: false,
  },
  {
    label: '🎁',
    name: 'BONO 1: Diccionario Universal de Puntos',
    detail: 'Puntos y abreviaturas, en español',
    value: 4500,
    isBonus: true,
  },
  {
    label: '🎁',
    name: 'BONO 2: Guía de Materiales Recomendados',
    detail: 'Qué comprar y dónde, sin gastar de más',
    value: 5000,
    isBonus: true,
  },
  {
    label: '🎁',
    name: 'BONO 3: Los 5 Patrones de Práctica',
    detail: 'Nivel inicial a pro, paso a paso',
    value: 3000,
    isBonus: true,
  },
]

export const testimonials = [
  {
    quote:
      'Tenía miedo de comprar por internet y no entender cómo bajar el curso, pero fue súper fácil. A los 5 minutos ya tenía el manual en mi WhatsApp y en el correo. Las explicaciones son claritas, parece que tenés a la profesora al lado. ¡Ya terminé mi primer osito para mi nieta!',
    author: 'Marta S.',
    details: '62 años, Córdoba',
  },
  {
    quote:
      'Intenté mil veces con tutoriales de YouTube y siempre me quedaban los puntos flojos o no entendía cómo cerrar el tejido. Con el Método Maestro por fin entendí el famoso "círculo mágico". El diccionario de puntos es un antes y un después. ¡Por fin mis amigurumis parecen profesionales!',
    author: 'Lucía G.',
    details: '34 años, Buenos Aires',
  },
  {
    quote:
      'Dudé por el precio, pero hoy te digo que vale cada peso. Con el primer muñeco que vendí ya recuperé lo que pagué por el método. Las técnicas de costura invisible que enseñan hacen que el trabajo quede impecable. ¡Es una inversión, no un gasto!',
    author: 'Romina F.',
    details: '28 años, Rosario',
  },
  {
    quote:
      'Nunca había tocado una aguja de crochet en mi vida. Pensé que iba a ser imposible, pero el paso a paso es tan visual que no hay forma de perderse. Empecé el lunes y el domingo ya tenía mi primer amigurumi terminado. ¡Es adictivo!',
    author: 'Carla M.',
    details: '41 años, Mendoza',
  },
]

export const faqs = [
  {
    question: '¿Necesito saber tejer antes?',
    answer:
      'Absolutamente no. Empezamos desde cómo sostener la aguja. Es ideal para principiantes totales.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Apenas realices el pago, recibís un mail con el acceso inmediato a todo el contenido digital para descargar en tu celular o compu.',
  },
  {
    question: '¿Tengo que comprar materiales caros?',
    answer:
      'No. En la guía te enseñamos cómo empezar con lo básico que podés encontrar en cualquier mercería de barrio.',
  },
]

export const formatArs = (value: number) =>
  '$' + value.toLocaleString('es-AR')
